export default __webpack_public_path__ + "static/media/Liked.cab8a159.svg";